var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('h3',{staticClass:"mb-5"},[_vm._v(" 5 departments")]),_c('div',{staticClass:"row row-cols-1 row-cols-sm-2 row-cols-xl-3"},_vm._l((_vm.departments),function(department){return _c('div',{key:`department-`+department.id,staticClass:"col mb-3 mb-lg-5"},[_c('department-card',{attrs:{"department":department}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }